// I ett produktionsbygge ligger API:t på samma domän som sidan, så en relativ adress räcker. Tidigare var
// utvecklingsadressen standard, och den kom med i TeamCitys bygge (.env.production ligger inte i git) -
// den publicerade sajten anropade då localhost:7050 (Henrik 2026-09-12).
export const apiBaseUrl =
    import.meta.env.VITE_API_BASE_URL ?? (import.meta.env.DEV ? "https://localhost:7050/api" : "/api");
